<template>
  <div class="mobile-footer">
    <nav class="mobile-footer__bar" dir="rtl" aria-label="bottom navigation">
      <router-link
        v-if="!$store.state.teacherAccess"
        to="/"
        class="mobile-footer__item"
        :class="{ 'is-active': isActive('/') }"
      >
        <v-icon size="22">mdi-home-outline</v-icon>
        <span>{{ $t("home") }}</span>
      </router-link>
      <router-link
        v-else
        to="/academy/dashboard"
        class="mobile-footer__item"
        :class="{ 'is-active': isActive('/academy/dashboard') }"
      >
        <v-icon size="22">mdi-home-outline</v-icon>
        <span>{{ $t("home") }}</span>
      </router-link>
      <router-link
        v-if="!$store.state.teacherAccess"
        to="/sell/list"
        class="mobile-footer__item"
        :class="{ 'is-active': isActive('/sell') }"
      >
        <v-icon size="22">mdi-shopping-outline</v-icon>
        <span>{{ $store.state.shopSystem ? $t("orders") : $t("sell") }}</span>
      </router-link>
      <div v-else class="mobile-footer__item mobile-footer__item--spacer" />
      <button
        type="button"
        class="mobile-footer__item mobile-footer__item--menu"
        :aria-label="menuCaption"
        @click="menuHubOpen = true"
      >
        <span class="mobile-footer__menu-btn">
          <my-icon
            name="menu-layout-icon"
            :width="20"
            :height="20"
            stroke="#FFFFFF"
            :cursor-pointer="true"
          />
        </span>
      </button>
      <router-link
        v-if="!$store.state.teacherAccess"
        to="/product/list"
        class="mobile-footer__item"
        :class="{ 'is-active': isActive('/product') }"
      >
        <v-icon size="22">mdi-cube-outline</v-icon>
        <span>{{ $t("product") }}</span>
      </router-link>
      <div v-else class="mobile-footer__item mobile-footer__item--spacer" />
      <router-link
        v-if="!$store.state.teacherAccess"
        to="/setting/index"
        class="mobile-footer__item"
        :class="{ 'is-active': isActive('/setting') }"
      >
        <v-icon size="22">mdi-cog-outline</v-icon>
        <span>{{ $t("setting") }}</span>
      </router-link>
      <div v-else class="mobile-footer__item mobile-footer__item--spacer" />
    </nav>

    <MenuHubMobile v-model="menuHubOpen" />
  </div>
</template>

<script>
import MyIcon from "@/views/dashboard/components/general/icon/MyIcon.vue";
import MenuHubMobile from "@/views/dashboard/components/core/appbar/mobile/MenuHubMobile.vue";

export default {
  name: "DashboardCoreFooter",
  components: {
    MyIcon,
    MenuHubMobile,
  },
  data() {
    return {
      menuHubOpen: false, 
    };
  },
  computed: {
    menuCaption() {
      const t = this.$t("menu");
      if (t && t !== "menu") return t;
      return "منو";
    },
  },
  methods: {
    isActive(prefix) {
      const path = this.$route.path || "";
      if (prefix === "/") {
        return path === "/" || path === "";
      }
      return path === prefix || path.startsWith(prefix + "/");
    },
  },
};
</script>

<style scoped>
.mobile-footer {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 6;
  pointer-events: none;
}

.mobile-footer__bar {
  pointer-events: auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 56px;
  padding: 4px 8px calc(4px + env(safe-area-inset-bottom, 0px));
  background: rgba(255, 255, 255, 0.96);
  border-top: 1px solid #e8edf2;
  border-top-left-radius: 18px;
  border-top-right-radius: 18px;
  box-shadow: 0 -4px 18px rgba(15, 35, 60, 0.06);
  backdrop-filter: blur(10px);
}

.mobile-footer__item {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 2px;
  min-width: 0;
  padding: 2px;
  border: 0;
  background: transparent;
  color: #90a4ae;
  text-decoration: none;
  font-size: 11px;
  font-weight: 500;
  line-height: 1.2;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
}

.mobile-footer__item span {
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.mobile-footer__item .v-icon {
  color: inherit !important;
}

.mobile-footer__item.is-active {
  color: #5b7c99;
}
.mobile-footer__item--menu {
  color: #5b7c99;
}

.mobile-footer__menu-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  border-radius: 14px;
  background: #5b7c99;
}

.mobile-footer__item--spacer {
  visibility: hidden;
  pointer-events: none;
}
</style>
